import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import flightSearchEndpoints, { type as priceType } from './flightSearchEndpoints';
export const api = createApi({
    reducerPath: 'searchWidgetApi',
    baseQuery: fetchBaseQuery({ baseUrl: process.env.REACT_APP_API_ENDPOINT }),
    tagTypes: [priceType],
    keepUnusedDataFor: 5,
    refetchOnMountOrArgChange: 5,
    endpoints: (builder) => ({
        ...flightSearchEndpoints(builder),
    })
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
    useGetPricesReturnQuery,
    useGetPricesOutboundQuery,

    endpoints
} = api;

export default api;